import { format } from "date-fns";
import { casesActions } from "configs";
import {
  generateId,
  useCurrentCase,
  useDispatch,
  useInitializeOfflineData,
  useParams
} from "duck";
import { useCreateDefibMedicationMutation } from "requests";
import { FormValues } from "./types";

export const useCreateDefibMedication = () => {
  const { id: caseId } = useParams();
  const dispatch = useDispatch();
  const [create] = useCreateDefibMedicationMutation();
  const { shouldSync, patientId } = useCurrentCase(medicalCase => ({
    shouldSync: medicalCase.shouldSync,
    patientId: medicalCase.data.client.patient._id
  }));
  const { loadMedications } = useInitializeOfflineData();

  return (values: FormValues) => {
    const variables = {
      medication: values.name,
      doseMax: values.doseMax,
      doseMin: values.doseMin,
      initials: values.initials
    };

    if (shouldSync) {
      return create({
        variables: {
          input: {
            patient: patientId,
            timeAdministered: values.timeAdministered,
            ...variables
          }
        }
      }).then(response => {
        loadMedications();
        const defibMed = response.data?.createDefibMedication?.defibMedication;
        if (defibMed) {
          dispatch(
            casesActions.addDefibMedication({ data: defibMed, _id: caseId })
          );
        }
      });
    }

    dispatch(
      casesActions.addDefibMedication({
        _id: caseId,
        data: {
          fakeId: generateId(),
          timeAdministered: values.timeAdministered
            ? format(values.timeAdministered, "k:mm:ssxxx")
            : null,
          ...variables
        }
      })
    );

    return Promise.resolve();
  };
};
